interface VerifiedBadgeProps {
  size?: number;
  className?: string;
}

export function VerifiedBadge({ size = 14, className = '' }: VerifiedBadgeProps) {
  return (
    <img
      src="/assets/rankbadges/verified.png"
      alt="Verified"
      className={`inline-block shrink-0 ${className}`}
      style={{ width: size, height: size, objectFit: 'contain', verticalAlign: 'middle' }}
    />
  );
}
